// extracted by css-extract-rspack-plugin
export default {"visuallyHidden":"oTTJX"};